// Additional polyfills
import 'custom-event-polyfill'
import 'url-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import globals from './globals'
import Popper from 'popper.js'
import mixin from './mixin'
import mixinServices from './mixin-services'
import store from './store'
import moment from 'moment'
import VueGtag from 'vue-gtag'
import { Bugfender } from '@bugfender/sdk'

Vue.use(VueGtag, {
  config: { id: 'G-0FNBRH2XVN' }, // GA_MEASUREMENT_ID
  enabled: process.env.VUE_APP_MODE === 'production',
  bootstrap: process.env.VUE_APP_MODE === 'production'
}, router)

Bugfender.init({
  appKey: 'wsHDT61jeBUYPpTkcbg5obP6jbrCJJf5',
  // apiURL: 'https://api.bugfender.com/', //Usually not required, should be used for on-premises or custom data centers
  // baseURL: 'https://dashboard.bugfender.com',  //Usually not required, should be used for on-premises or custom data centers
  // deviceName: '',
  // overrideConsoleMethods: true,
  printToConsole: true,
  // registerErrorHandler: true,
  logBrowserEvents: true,
  logUIEvents: false,
  version: process.env.VUE_APP_VERSION
  // build: '',
})

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false

Vue.use(BootstrapVue)

// Globally set locale to spanish
moment.locale('es')

// Global RTL flag
Vue.mixin({
  data: globals,
  mixins: [mixin, mixinServices]
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
